import { MAIN_BLUE } from '../color';
import {
  SET_SELECTED_MONTH_RANGE,
  RESET_SELECTED_MONTH_RANGE,
} from '../constants';

const initial = {
  selectedRange: [],
};

export default (state = initial, event) => {
  switch (event.type) {
    case SET_SELECTED_MONTH_RANGE:
      return {
        ...state,
        selectedRange: event.data.selectedRange,
      };

    case RESET_SELECTED_MONTH_RANGE:
      return {
        ...state,
        selectedRange: [],
      };
    default:
      return state;
  }
};
